import { render, staticRenderFns } from "./lookupTool.vue?vue&type=template&id=6c4a7d3d&scoped=true&"
import script from "./lookupTool.vue?vue&type=script&lang=tsx&"
export * from "./lookupTool.vue?vue&type=script&lang=tsx&"
import style0 from "./lookupTool.vue?vue&type=style&index=0&id=6c4a7d3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a7d3d",
  null
  
)

export default component.exports